import _ from 'lodash';
import { TranslateResult } from 'vue-i18n';

class EnumDescription {
  public value!: string;
  public text!: TranslateResult;
  public key?: string;
  public icon?: string;
}

export class EnumDescriptions {
  private static objCache: {}[] = [];
  private static cache: EnumDescription[][] = [];

  public static setDescriptions(
    enumClass: {},
    descriptions?: TranslateResult[]
  ): void {
    this.populate(enumClass, descriptions);
  }

  private static populate(
    enumClass: {},
    descriptions?: TranslateResult[]
  ): EnumDescription[] {
    let indexCache = _.indexOf(this.objCache, enumClass);
    if (indexCache < 0) {
      indexCache = this.objCache.push(enumClass) - 1;

      const keys = Object.keys(enumClass);
      const originalDescriptions = keys.slice(keys.length / 2);
      const originalKeys = keys.slice(0, keys.length / 2);

      if (descriptions == null) descriptions = originalDescriptions;
      else if (descriptions.length !== originalDescriptions.length)
        throw 'Invalid descriptions length: ' +
          JSON.stringify(originalDescriptions);

      this.cache[indexCache] = _.map(descriptions, (description, index) => {
        return {
          value: originalDescriptions[index],
          text: description,
          key: originalKeys[index],
        };
      });
    }
    return this.cache[indexCache];
  }

  public static get(enumClass: {}): EnumDescription[] {
    return this.populate(enumClass);
  }

  public static get2(enumClass: {}, item: string | number): string {
    if (!_.isUndefined(item)) {
      const enums: EnumDescription[] = this.get(enumClass);
      const findEnum = _.isString(item)
        ? (_.find(enums, { value: item }) as EnumDescription)
        : (_.find(enums, { key: item.toString() }) as EnumDescription);
      if (findEnum) return findEnum.text.toString();
    }
    return '--';
  }

  public static customEnum(enumClass: {}, items: string[]): EnumDescription[] {
    const enums: EnumDescription[] = this.get(enumClass);
    const customEnum: EnumDescription[] = [];
    items.forEach((x) => {
      enums.forEach((element) => {
        if (element.value == x) {
          customEnum.push(element);
        }
      });
    });
    return customEnum;
  }
}
